import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Login from "./pages/Login";
import Dashboard_Layout from "./components/dashboard/Dashboard_Layout";
import Dashboard from "./pages/Dashboard";
import AddCategory from "./pages/add-edit/category/AddCategory";
import { ToastContainer } from "react-toastify";
import { getCategory } from "./redux/category/CategorySlice";
import { getNewsAdmin } from "./redux/news/NewsSlice";
import ListCategory from "./pages/add-edit/category/ListCategory";
import UpdateCategory from "./pages/add-edit/category/UpdateCategory";
import AddNews from "./pages/news_management/AddNews";
import ListNews from "./pages/news_management/ListNews";
import UpdateNews from "./pages/news_management/UpdateNews";
import UnPublishedNews from "./pages/news_management/UnPublishedNews";
import CancelledNews from "./pages/news_management/CancelledNews";
import { fetchDistricts, fetchMandals } from "./redux/district/districtSlice";
import AddReporter from "./pages/reporter_management/AddReporter";
import ReporterApprovedList from "./pages/reporter_management/ReporterApprovedList";
import ReporterNotApprovedList from "./pages/reporter_management/ReporterNotApprovedList";
import ReporterBlockList from "./pages/reporter_management/ReporterBlockList";
import ReporterList from "./pages/reporter_management/ReporterList";
import { getReporterAll } from "./redux/reporter/ReporterSlice";
import AddMandal from "./pages/AddMandal/AddMandal";
import MandalsTable from "./pages/AddMandal/MandalsTable";
import BirthdayImages from "./pages/birthday_management/BirthdayImages";
import ViralImages from "./pages/viral_management/ViralImages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCategory());
    dispatch(getNewsAdmin());
    dispatch(fetchDistricts());
    dispatch(getReporterAll());
    dispatch(fetchMandals());
  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/admin" exact element={<Dashboard_Layout />}>
            <Route path="/admin" index element={<Dashboard />} />

            <Route path="/admin/add-category" element={<AddCategory />} />
            <Route path="/admin/list-category" element={<ListCategory />} />
            <Route
              path="/admin/update-category/:caturl"
              element={<UpdateCategory />}
            />

            <Route path="/admin/add-news" element={<AddNews />} />
            <Route path="/admin/list-news" element={<ListNews />} />
            <Route
              path="/admin/update-news/:newsurl"
              element={<UpdateNews />}
            />
            <Route
              path="/admin/unpublished-news"
              element={<UnPublishedNews />}
            />
            <Route path="/admin/cancelled-news" element={<CancelledNews />} />

            <Route path="/admin/add-mandal" element={<AddMandal />} />
            <Route path="/admin/list-mandal" element={<MandalsTable />} />

            <Route path="/admin/birthday-images" element={<BirthdayImages />} />
            <Route path="/admin/viral-images" element={<ViralImages />} />

            <Route path="/admin/add-reporter" element={<AddReporter />} />
            <Route
              path="/admin/approved-list-reporter"
              element={<ReporterApprovedList />}
            />
            <Route
              path="/admin/not-approved-list-reporter"
              element={<ReporterNotApprovedList />}
            />
            <Route
              path="/admin/blocked-list-reporter"
              element={<ReporterBlockList />}
            />
            <Route path="/admin/all-list-reporter" element={<ReporterList />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
